import { combineReducers } from "@reduxjs/toolkit";
import globalSlice from "./global.slice";
import organizationSlice from "../pages/organization/services/slice";
import loginSlice from "../pages/login/services/login.slice";

const rootReducer = combineReducers({
  global: globalSlice,
  organization: organizationSlice,
  login: loginSlice,
});

export default rootReducer;
